module.exports = __webpack_public_path__ + "img/discord_bot_canvas.3e44cfec.png";